module.exports = __webpack_public_path__ + "static/img/icon6.3deeee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon6.png
// module id = OAQh
// module chunks = 4